<div class="zeva-card padded banner">
  <p class="tagline">{{ 'sidenav.upgrade_banner.tagline' | transloco }}</p>
  <p class="title mat-headline-3">{{ 'sidenav.upgrade_banner.title' | transloco }}</p>
  <p class="caption">{{ 'sidenav.upgrade_banner.description' | transloco }}</p>

  <!-- <div class="features">
    <div>
      <mat-icon>directions_car</mat-icon>
      <span>{{ 'sidenav.upgrade_banner.feature_1' | transloco }}</span>
      <mat-icon svgIcon="lock" class="lock"></mat-icon>
    </div>
    <div>
      <mat-icon>speed</mat-icon>
      <span>{{ 'sidenav.upgrade_banner.feature_2' | transloco }}</span>
      <mat-icon svgIcon="lock" class="lock"></mat-icon>
    </div>
    <div>
      <mat-icon>query_stats</mat-icon>
      <span>{{ 'sidenav.upgrade_banner.feature_3' | transloco }}</span>
      <mat-icon svgIcon="lock" class="lock"></mat-icon>
    </div>
    <div>
      <mat-icon>notifications</mat-icon>
      <span>{{ 'sidenav.upgrade_banner.feature_4' | transloco }}</span>
      <mat-icon svgIcon="lock" class="lock"></mat-icon>
    </div>
  </div> -->

  <div class="button-wrapper">
    <a routerLink="/auth/connect-vehicles/">
      <button matButton="filled">
        {{ 'get_started' | transloco }}
      </button>
    </a>

    <a href="https://zevaglobal.com/fleets/" target="_blank">
      <button matButton="outlined">
        {{ 'learn_more' | transloco }}
      </button>
    </a>
  </div>
</div>
